/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_NowInputs */



/**
* | output |
* | --- |
* | "Update Now" |
*
* @param {Update_NowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_now = /** @type {((inputs?: Update_NowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_NowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour maintenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna ora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить сейчас")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar ahora")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("立即更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今すぐ更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी अद्यतन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize agora")
	return /** @type {LocalizedString} */ ("Update Now")
});